import React from 'react';

const ProviderOutsideMatchesContext = React.createContext();

export const ProviderOutsideMatchesContextProvider = ({ children }) => {
    const [hasOutsideMatches, setHasOutsideMatches] = React.useState();
    const [isVpcOutsideMatches, setIsVpcOutsideMatches] = React.useState(false);
    const [vpcResults, setVpcResults] = React.useState([]);

    const value = React.useMemo(
        () => ({
            hasOutsideMatches,
            setHasOutsideMatches,
            isVpcOutsideMatches,
            setIsVpcOutsideMatches,
            vpcResults,
            setVpcResults,
        }),
        [hasOutsideMatches, isVpcOutsideMatches, vpcResults],
    );

    return (
        <ProviderOutsideMatchesContext.Provider value={value}>
            {children}
        </ProviderOutsideMatchesContext.Provider>
    );
};

export const useProviderOutsideMatchesContext = () => {
    const context = React.useContext(ProviderOutsideMatchesContext);

    if (context == null) {
        throw new Error(
            `'useProviderOutsideMatchesContext' needs to be within 'ProviderOutsideMatchesContext'`,
        );
    }

    return context;
};
